import { render } from "./LandingPage.vue?vue&type=template&id=284895c0"
const script = {}

import "./LandingPage.vue?vue&type=style&index=0&id=284895c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__